import React from "react";
import { Col } from "reactstrap";
import "./index.scss";

const PageLoader = () => {
  return <Col className="loaderWrapper">Loading...</Col>;
};

export default PageLoader;
